import { render, staticRenderFns } from "./ActivePlans.vue?vue&type=template&id=6b50e9ae&"
import script from "./ActivePlans.vue?vue&type=script&lang=js&"
export * from "./ActivePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports